module.exports = __webpack_public_path__ + "img/icon_1_30.e67937be.png";